module.exports = __webpack_public_path__ + "app-static/img/20.8eec71d3.png";